import { Locale } from '@superbet-group/web.types';
import { PluginObject } from 'vue';

import { getTranslationsService } from './translationsService';
import {
    createTranslationsInstance,
    PluralizationResolver,
} from './translate';

export const NamespacedTranslationsPlugin: PluginObject<TranslationPluginOptions> = {
    install(Vue: any, options?: TranslationPluginOptions) {
        if (!options) {
            throw new Error('Translations plugin requires options');
        }

        const { namespace, baseUrl, locale, pluralizationResolver, initialTranslations } = options;
        const {
            setTranslations,
            translate,
            translatePluralized,
        } = createTranslationsInstance(initialTranslations, pluralizationResolver);

        const translationsService = getTranslationsService(baseUrl, locale);
        translationsService.loadTranslations().then(() => {
            return setTranslations(translationsService.getTranslations());
        }).catch((error) => {
            console.error('Failed to load translations:', error);
        });

        if (!Vue.prototype[namespace]) {
            // eslint-disable-next-line no-param-reassign
            Vue.prototype[namespace] = {};
        }

        // eslint-disable-next-line no-param-reassign
        Vue.prototype[namespace].$t = translate;
        // eslint-disable-next-line no-param-reassign
        Vue.prototype[namespace].$tc = translatePluralized;
    },
};

export type NamespacedTranslationsInstance = {
    $t: (key: string, ...args: unknown[]) => string;
    $tc: (key: string, choice?: number, ...args: unknown[]) => string;
};

type TranslationPluginOptions = {
    namespace: string;
    baseUrl: string;
    locale: Locale;
    initialTranslations?: Record<string, string>;
    pluralizationResolver?: PluralizationResolver;
};
